import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowDashboardComponent } from './workflow-dashboard/workflow-dashboard.component';
import { WorkflowRoutingModule } from './workflow-routing.module';
import { SharedModule } from '../shared/shared.module';
import {WfTemplateComponent} from './wf-template/wf-template.component'
// import { WfTemplateComponent } from '../wf-template/wf-template.component';
import { WorkflowDesignerComponent } from './workflow-designer/workflow-designer.component';
import { WfWorkComponent } from './wf-work/wf-work.component';



@NgModule({
  declarations: [
    WorkflowDashboardComponent,
    WfTemplateComponent,
    WorkflowDesignerComponent,
    WfWorkComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    WorkflowRoutingModule
  ]
})
export class WorkflowModule { }
